import { default as Mui4Tab } from '@material-ui/core/Tab'
import { default as Mui5Tab, TabProps as Mui5TabProps } from '@mui/material/Tab'
import { forwardRef } from 'react'
import { useComponentVersion } from '../../hooks/useComponentVersion'
import { styled } from '../../styles'
import { Badge } from '../Badge'
import { OsTabsVersion } from './Tabs'

export const StyledNumberIcon = styled('span')(({ theme }) => ({
  backgroundColor: `${theme.palette.neutralGrey[300]}`,
  padding: '0px 4px',
  borderRadius: 4,
}))

export type TabProps = Mui5TabProps & {
  count?: number
  isSelected?: boolean
}

export const Tab = forwardRef<HTMLDivElement, TabProps>((props, ref) => {
  const version = useComponentVersion('tabs')

  const { count = 0, icon, isSelected, ...rest } = props

  const renderIcon = () => {
    return (
      <>
        {icon}
        {count > 0 && (
          <Badge size="small" color={isSelected ? 'info' : 'primary'}>
            {count > 9 ? '9+' : count}
          </Badge>
        )}
      </>
    )
  }

  switch (version) {
    case OsTabsVersion.V2:
      return <Mui5Tab ref={ref} {...rest} icon={renderIcon()} />
    default:
      //@ts-ignore
      return <Mui4Tab ref={ref} {...rest} icon={renderIcon()} />
  }
})
